export const styles = {
  successRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  successIconBox: {
    width: 28,
    height: 28,
    borderRadius: 10,
    background: '#EEF2F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  card: {
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    padding: 18,
  },

  divider: {
    width: '100%',
    height: 1,
    backgroundColor: '#D1D5DB',
    margin: '10px 0 6px',
  },

  linkRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginTop: 10,
  },

  linkInput: {
    flex: 1,
    minWidth: 0,
    height: 36,
    borderRadius: 8,
    border: '1px solid #D1D5DB',
    padding: '0 12px',
    fontSize: 13,
    outline: 'none',
    background: '#FFFFFF',
    color: '#111827',
  },

  copyBtn: {
    width: 38,
    height: 36,
    borderRadius: 10,
    border: '1px solid #D1D5DB',
    background: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  chipsRow: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    marginTop: 12,
  },
  
   copyBtnCopied: {
    borderColor: '#16A34A',
    background: '#ECFDF5',
  },

  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 999,
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    fontSize: 12,
    color: '#111827',
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    flexWrap: 'wrap',
    marginTop: 18,
  },
};
